module.exports = __webpack_public_path__ + "static/media/24.1e44a87c.png";